module.exports = __webpack_public_path__ + "static/media/tm-colorit-9.1d54334c.webp";